"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var CreateTransferTemplate = /** @class */ (function () {
    function CreateTransferTemplate() {
        this.title = '';
        this.status = 'pending';
        this.products = [
            new CreateTransferTemplateProduct(),
        ];
    }
    Object.defineProperty(CreateTransferTemplate.prototype, "locationIds", {
        get: function () {
            var locations = [];
            if (this.fromLocationId) {
                locations.push(this.fromLocationId);
            }
            if (this.products.length > 0 && this.products[0].quantities.length > 0) {
                locations.push(this.products[0].quantities[0].locationId);
            }
            return locations;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateTransferTemplate.prototype, "productIds", {
        get: function () {
            return this.products.filter(function (p) { return p.id; }).map(function (p) { return p.id; });
        },
        enumerable: true,
        configurable: true
    });
    CreateTransferTemplate.prototype.addProduct = function (productId, productName, unit) {
        var createObject = new CreateTransferTemplateProduct(productId, productName, unit);
        if (this.products.length > 0) {
            var quantities = this.products[0].quantities;
            createObject.quantities = quantities.map(function (q) { return new CreateTransferTemplateProductQuantity(q.locationId, q.unit); });
        }
        this.products.push(createObject);
    };
    CreateTransferTemplate.prototype.removeProduct = function (productId) {
        this.products = this.products.filter(function (p) { return p.id !== productId; });
    };
    CreateTransferTemplate.prototype.addLocation = function (locationId) {
        this.products.forEach(function (p) {
            if (p.quantities.find(function (q) { return q.locationId === locationId; })) {
                // Location already exists, don't add
            }
            else {
                p.quantities.push(new CreateTransferTemplateProductQuantity(locationId, p.unit));
            }
        });
    };
    CreateTransferTemplate.prototype.removeLocation = function (locationId) {
        this.products.forEach(function (p) {
            p.quantities = p.quantities.filter(function (q) { return q.locationId !== locationId; });
        });
    };
    CreateTransferTemplate.prototype.getNetworkObject = function () {
        return {
            title: this.title,
            fromLocationId: this.fromLocationId,
            status: this.status,
            products: this.products.filter(function (p) { return p.id !== undefined; }).map(function (p, index) {
                p.indexOrder = index;
                return p.getNetworkObject();
            }),
        };
    };
    CreateTransferTemplate.prototype.populate = function (json) {
        Object.assign(this, json);
        this.products = json.products.map(function (p) {
            var product = new CreateTransferTemplateProduct();
            product.populate(p);
            return product;
        });
    };
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplate.prototype, "title", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplate.prototype, "fromLocationId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplate.prototype, "status", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplate.prototype, "products", void 0);
    __decorate([
        mobx_1.computed
    ], CreateTransferTemplate.prototype, "locationIds", null);
    __decorate([
        mobx_1.computed
    ], CreateTransferTemplate.prototype, "productIds", null);
    return CreateTransferTemplate;
}());
exports.CreateTransferTemplate = CreateTransferTemplate;
var CreateTransferTemplateProduct = /** @class */ (function () {
    function CreateTransferTemplateProduct(id, name, unit) {
        this.quantities = [];
        this.id = id;
        this.name = name;
        this.unit = unit;
    }
    CreateTransferTemplateProduct.prototype.populate = function (json) {
        var _this = this;
        Object.assign(this, json);
        this.quantities = json.quantities.map(function (q) {
            var quantity = new CreateTransferTemplateProductQuantity(0, 'unit');
            quantity.populate(q);
            _this.unit = quantity.unit;
            return quantity;
        });
    };
    CreateTransferTemplateProduct.prototype.getNetworkObject = function () {
        return {
            id: this.id,
            name: this.name,
            indexOrder: this.indexOrder,
            quantities: this.quantities.map(function (q, index) {
                q.indexOrder = index;
                return q;
            }),
        };
    };
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplateProduct.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplateProduct.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplateProduct.prototype, "unit", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplateProduct.prototype, "indexOrder", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplateProduct.prototype, "quantities", void 0);
    return CreateTransferTemplateProduct;
}());
exports.CreateTransferTemplateProduct = CreateTransferTemplateProduct;
var CreateTransferTemplateProductQuantity = /** @class */ (function () {
    function CreateTransferTemplateProductQuantity(locationId, unit) {
        this.indexOrder = 0;
        this.quantity = 0;
        this.locationId = locationId;
        this.unit = unit;
    }
    CreateTransferTemplateProductQuantity.prototype.populate = function (json) {
        Object.assign(this, json);
    };
    CreateTransferTemplateProductQuantity.prototype.getNetworkObject = function () {
        return {
            locationId: this.locationId,
            indexOrder: this.indexOrder,
            quantity: this.quantity,
            unit: this.unit,
        };
    };
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplateProductQuantity.prototype, "locationId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplateProductQuantity.prototype, "indexOrder", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplateProductQuantity.prototype, "quantity", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransferTemplateProductQuantity.prototype, "unit", void 0);
    return CreateTransferTemplateProductQuantity;
}());
exports.CreateTransferTemplateProductQuantity = CreateTransferTemplateProductQuantity;
//# sourceMappingURL=TransferTemplate.js.map